import _regeneratorRuntime from "@babel/runtime/regenerator";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import * as Comlink from 'comlink';
var Logic = Comlink.wrap(new Worker('../GameLogic/Logic', {
  type: 'module'
}));
var instance = null;
export default /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
  return _regeneratorRuntime.wrap(function _callee$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          if (!(instance === null)) {
            _context.next = 4;
            break;
          }

          _context.next = 3;
          return new Logic();

        case 3:
          instance = _context.sent;

        case 4:
          return _context.abrupt("return", instance);

        case 5:
        case "end":
          return _context.stop();
      }
    }
  }, _callee);
}));